import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { GoogleAppDetailsTileModel, updateGoogleTile } from "client/Api/Workspace/workspace";

export type EditGoogleTileProps = EditGenericWithDestinationWindowTilePropsBase<GoogleAppDetailsTileModel>;

export const EditGoogleTile = forwardRef(
	(props: EditGoogleTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateGoogleTile}
				ref={ref}
			/>
		);
	}
);
EditGoogleTile.displayName = "EditGoogleTile";
